export function normalizeConsentKey(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
}

export function isMultilingualVariant(data) {
  return Boolean(data && (data.kind === 'multilingual_consent' || data.is_multilingual_variant));
}

export function buildMultilingualVariantPayload({ parentType, parentLabel, languageLabel, languageCode, consentMessage, title = '', parentSubConsentId = null, parentConsentId = null, subConsentId = null, icon = 'FileText', color = '#0070f3' }) {
  const payload = {
    kind: 'multilingual_consent',
    parent_consent_type: parentType,
    parent_consent_label: parentLabel,
    title: title || parentLabel,
    language: languageLabel,
    language_code: languageCode,
    icon,
    color,
    consent_message: consentMessage,
  };
  if (parentSubConsentId != null) payload.parent_sub_consent_id = parentSubConsentId;
  if (subConsentId != null || parentSubConsentId != null) payload.sub_consent_id = subConsentId ?? parentSubConsentId;
  if (parentConsentId != null) {
    payload.parent_consent_id = parentConsentId;
    payload.consent_id = parentConsentId;
  }
  return payload;
}
